module.exports = __webpack_public_path__ + "static/img/newlogo2.455e130.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newlogo2.png
// module id = AfBy
// module chunks = 1